import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { LinkToAddTestCase } from '@eggplant/routing'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import {
  Paragraph,
  SingleSelect
} from '@eggplant/pattern-library'
import type {
  GetTestCasesResponse,
  Options
} from '@eggplant/types'

interface Props {
  initialOptions?: Options
  modelId?: string
  prompt?: string
  onChange: (value: string) => void
  onSuccess?: (data: GetTestCasesResponse) => void
  value: string
  isRequired?: boolean
  isDisabled?: boolean
}

const url = MODELER_SERVICE + '/test_cases'

const getOptions = (data: GetTestCasesResponse) =>
  data.items
    .filter(item =>
      !!item.id
    )
    .map(item => ({
      label: item.name,
      value: item.id
    }))

const SelectModelerTestCase = ({
  initialOptions = [],
  modelId,
  prompt = 'Select a test case',
  onChange,
  onSuccess,
  value,
  isRequired,
  isDisabled = false
}: Props) => {
  const params = {
    model_id: modelId,
    sort: '+name'
  }

  const handleChange = (value: string) => {
    onChange(value)
  }

  return (
    <AuthenticatedDataRequest
      method='get'
      onSuccess={onSuccess}
      params={params}
      url={url}
    >
      {
        (data: GetTestCasesResponse) => data.total_count
          ? (
            <SingleSelect
              isDisabled={isDisabled}
              isRequired={isRequired}
              label='Select a test case'
              onChange={handleChange}
              options={[
                ...initialOptions,
                ...getOptions(data)
              ]}
              prompt={prompt}
              value={value}
            />
          )
          : (
            <Paragraph>
              <LinkToAddTestCase
                model_id={modelId}
              >
                Create
              </LinkToAddTestCase>
              &nbsp;a test case
            </Paragraph>
          )

      }
    </AuthenticatedDataRequest>
  )
}

export default SelectModelerTestCase
